<template>
  <v-card flat>
    <v-card-title> Taxas de reajuste </v-card-title>
    <v-card-text>
      <v-expansion-panels>
        <v-expansion-panel v-for="tax in taxes" :key="tax.key">
          <v-expansion-panel-header>
            {{ tax.name }}
            <v-spacer />
            <div class="flex-grow-0 mr-2">
              <v-chip v-if="tax.code" color="primary" x-small @click="goToBcb(tax.code)"> SGS: {{ tax.code }} </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <readjustment-table :taxes="items[tax.key]" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import SETTINGS from '@/services/settings'
import moment from 'moment'
import ReadjustmentTable from './ReadjustmentTable.vue'
moment.locale('pt-br')
export default {
  components: { ReadjustmentTable },
  data: () => ({
    tax: [],
    months: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    taxes: [
      { name: 'IPCA', key: 'IPCA', code: '433' },
      { name: 'IGP-M', key: 'IGPM', code: '189' },
      { name: 'IGP-M+', key: 'IGPM_PLUS', code: '189' },
      { name: 'INPC', key: 'INPC', code: '188' },
      { name: 'INCC', key: 'INCC', code: '192' },
      { name: 'SELIC', key: 'SELIC', code: '4390' },
    ],
  }),
  computed: {
    header() {
      return [
        {
          text: 'Ano',
          value: 'key',
        },
        ...this.months.map(month => ({
          text: month,
          value: month,
        })),
      ]
    },
    items() {
      const typeTaxes = this.tax.reduce((acc, tax) => {
        const type = tax.type

        if (!acc[type]) acc[type] = []

        acc[type].push(tax)

        return acc
      }, {})

      return typeTaxes
    },
  },
  methods: {
    async getTaxes() {
      try {
        this.loading = true
        const response = await SETTINGS.readjustmentTax.getAll()
        this.tax = response.readjustmentTaxes
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$toast.fire({
          icon: 'error',
          title: e.message || 'Erro ao carregar taxas',
        })
      }
    },
    goToBcb(code) {
      window.open(`https://api.bcb.gov.br/dados/serie/bcdata.sgs.${code}/dados`, '_blank')
    },
  },
  mounted() {
    this.getTaxes()
  },
}
</script>

<style></style>
